import StorageService from 'services/StorageService'

const pingTime = 60000;
let serviceInitied = false;

const _getSessionId = () => {
    const sessionId = StorageService.getItem('sessionId');
    if(sessionId) return sessionId;

    const anonymousId = btoa('vtexEventSessionId' + new Date().getTime() + (Math.random() * 1000));
    StorageService.setItem('anonymousSessionId', anonymousId);

    return anonymousId;
}

const _getAnonymousId = () => {
    let anonymousId = StorageService.getItem('anonymousId');

    if(!anonymousId){
        const data = StorageService.getSecureItem('userData');
        anonymousId = btoa((data && data.email ? data.email : 'vtexEventAnonymousId') + new Date().getTime() + (Math.random() * 1000));
        StorageService.setItem('anonymousId', anonymousId);
    }

    return anonymousId;
}

const _getPayload = () => {
    return {
        "session": _getSessionId(),
        "anonymous": _getAnonymousId(),
        "url": window.location.href,
        "agent": window.navigator.userAgent
    }
}

const _request = (payload) => {
    fetch('https://api.biggylabs.com.br/event-api/v1/jumbo/event', {
        method: 'POST',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    }).catch(() => false);
}

const ping = () => {
    if (typeof window === 'undefined') return false;

    let payload = _getPayload();
    payload.type = 'session.ping';

    _request(payload);
}

const updateCart = (items = []) => {
    if (typeof window === 'undefined') return false;

    let payload = _getPayload();
    payload.products = items.map(item => {
        return {
            product: item.id,
            quantity: item.quantity
        }
    });
    payload.type = items.length > 0 ? 'page.cart' : 'page.empty_cart';

    _request(payload);
}

const click = (skudId, searchTerm) => {
    let payload = _getPayload();
    payload.productId = skudId;
    payload.text = searchTerm;
    payload.type = 'search.click';

    _request(payload);
}

const query = (searchTerm, match) => {
    let payload = _getPayload();
    payload.misspelled = false;
    payload.text = searchTerm;
    payload.operator = 'and';
    payload.match = match;
    payload.type = 'search.query';

    _request(payload);
}

const pageConfirmation = (orderid, items) => {
    let payload = _getPayload();
    payload.type = 'page.confirmation';
    payload.order = orderid;
    payload.products = items.map(item => {
        return {
            productId: item.id,
            price: item.price,
            quantity: item.quantity
        }
    });

    _request(payload);
}

const sessionUser = (userData) => {
    let payload = _getPayload();
    payload.type = 'session.user';
    payload.user = userData.email;
    payload.name = userData.firstName + (userData.lastName ? ' ' + userData.lastName : '');
    payload.gender = userData.gender;
    payload.allowMailMarketing = true;

    _request(payload);
}

const init = () => {
    if(serviceInitied) return true;
    ping();
    setInterval(ping, pingTime);
    serviceInitied = true;
}

const VtexEvent = {
    init,
    ping,
    updateCart,
    click,
    query,
    pageConfirmation,
    sessionUser
}

export default VtexEvent;
